<template>
  <table class="table-hover reports-table daily-limits-table table">
    <tbody class="thead">
      <tr>
        <template v-if="walker.sub_show">
          <th>{{ walker.sub_label }}</th>
        </template>
        <th>Time spent</th>
        <th>Daily limit</th>
        <th>Percentage used</th>
        <th>Remaining</th>
      </tr>
    </tbody>
    <!-- eslint-disable vue/require-v-for-key -->
    <template v-for="section in tableData.sections">
      <tbody
        v-if="tableIsTeam"
        class="grouping-header"
      >
        <tr>
          <th>
            <template v-if="walker.main_type === 'user'">
              <div class="d-flex align-items-center gap-4">
                <ReportTableAvatar
                  :user-id="section.main_id"
                  :url="section.rows[0].record.avatar_url"
                />
                {{ section.main }}
              </div>
            </template>
            <template v-else-if="walker.main_type === 'date'">
              {{ formatDateLabel(section.main) }}
            </template>
            <template v-else>
              {{ section.main }}
            </template>
          </th>
          <th
            v-for="col in 4"
            :key="col"
          ></th>
        </tr>
      </tbody>
      <tbody class="tbody">
        <tr v-for="row in section.rows">
          <template v-if="walker.sub_show">
            <td v-if="row.sub_show_data">
              <ReportTableAvatar
                v-if="walker.sub_type === 'user'"
                :user-id="row.record.sub_id"
                :url="row.record.avatar_url"
              />
              <template v-if="walker.sub_type === 'date'">
                {{ formatDateLabel(row.record.sub) }}
              </template>
              <template v-else>
                {{ row.record.sub }}
              </template>
            </td>
            <td v-else></td>
          </template>
          <td>{{ row.record.used | formatDuration('auto', null, false, true) }}</td>
          <td>{{ (row.record.allowed_seconds || 0) | formatDuration('auto', null, false, true) }}</td>
          <td class="percentage-cell">
            <div class="progress-time-text">
              <AppProgressBar
                :tracked="row.record.used"
                :total="row.record.allowed_seconds"
                class="widget-progress"
              />
            </div>
            {{ row.record.used | percentage(row.record.allowed_seconds) }}
          </td>
          <td>{{ row.record.remaining | formatDuration('auto', null, false, true) }}</td>
        </tr>
      </tbody>
    </template>
    <!-- eslint-enable vue/require-v-for-key -->
  </table>
</template>
<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'DailyLimitsReportTable',
  props: {
    tableData: Object,
  },
  computed: {
    ...mapGetters(['tableIsTeam', 'walker', 'startWeekOn']),
    ...mapState(['organization']),
  },
  methods: {
    formatDateLabel(value) {
      return TimeUtils.format_date(TimeUtils.parse_internal_date(value));
    },
  },
};
</script>
